import { useContext } from 'react';
import { PermissionContext } from '../context';

export const usePermissionContext = () => {
    const context = useContext(PermissionContext);
    if (context === undefined) {
        throw new Error('usePermissionContext must be used within an PermissionProvider');
    }
    return context;
};